module.exports = __webpack_public_path__ + "yandex_kassa_sberpay.a4bab56a10734ca9a371cb9b950bb11b.png";